import React from 'react';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const List = ({ t, franchiseeId, ...rest }) => {
	const columns = [
		{
			header: t('Territory_City'),
			accessor: 'city',
			sortable: true
		},
		{
			header: t('Territory_Name'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('Territory_Description'),
			accessor: 'description'
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => <Link to={`/franchisees/${franchiseeId}/territories/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={faEdit} /> {t('Common_Edit')}</Link>
		}
	];

	return (
		<div>
			<PagedEntitiesList columns={columns} listActions={<NewButton newItemPath={`/franchisees/${franchiseeId}/territories/new`} />} {...rest} />
		</div>
	);
};

export default withTranslation()(List);